<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-menu
          v-model="menuFechaSolicitud"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ui-form-field"
              :value="fechaSolicitud"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              hide-details
            >
              <template v-slot:label>Fecha de solicitud <span class="red--text">*</span></template>
            </v-text-field>
          </template>
          <v-date-picker v-model="form.fechaSolicitud" @input="menuFechaSolicitud = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6">
        <v-menu
          v-model="menuFechaAsignacion"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ui-form-field"
              :value="fechaAsignacion"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              hide-details
            >
              <template v-slot:label>Fecha de asignación <span class="red--text">*</span></template>
            </v-text-field>
          </template>
          <v-date-picker v-model="form.fechaAsignacion" @input="menuFechaAsignacion = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          class="ui-form-field"
          label="Número de folio de resguardo"
          v-model="form.folioResguardo"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          hide-details
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-file-input
          class="ui-form-field"
          label="Evidencia"
          v-model="form.file"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          hide-details
        ></v-file-input>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          class="ui-form-field"
          v-model="selectedItems"
          label="Items"
          :items="catalogoItems"
          item-text="item"
          item-value="id"
          background-color="transparent"
          color="secondary"
          rounded
          filled
          dense
          :clearable="false"
          multiple
          chips
          small-chips
          deletable-chips
          hide-selected
          return-object
          hint="Selecciona uno o más items. Presiona la X en cada chip para quitar uno."
          persistent-hint
          @change="onItemsChange"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ item.item }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.CatTipoItem && item.CatTipoItem.title }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-textarea
          class="ui-form-field ui-form-textarea"
          label="Observaciones"
          v-model="form.observaciones"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          no-resize
          rows="6"
          hide-details
        ></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-progress-linear
          v-if="loadingItems"
          indeterminate
          color="secondary"
          rounded
          class="mb-2"
        ></v-progress-linear>
        <v-data-table
          :headers="headers"
          :items="itemsAsignar"
          class="ui-module-table"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:[`item.numero`]="{ item }">
            <span class="table-cell-text">{{ item.numero }}</span>
          </template>
          <template v-slot:[`item.fechaFabricacion`]="{ item }">
            <v-menu
              v-model="item._menuFab"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ui-form-field ui-form-field--inline"
                  :value="item.fechaFabricacion"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  rounded
                  filled
                  color="secondary"
                  background-color="transparent"
                  hide-details
                  placeholder="DD/MM/YYYY"
                  :disabled="item.sinExistencia"
                ></v-text-field>
              </template>
              <v-date-picker
                @input="(val) => { item.fechaFabricacion = formatDate(val); item._menuFab = false }"
              ></v-date-picker>
            </v-menu>
          </template>
          <template v-slot:[`item.aniosVigencia`]="{ item }">
            <v-menu
              v-model="item._menuVig"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ui-form-field ui-form-field--inline"
                  :value="item.aniosVigencia"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  rounded
                  filled
                  color="secondary"
                  background-color="transparent"
                  hide-details
                  placeholder="DD/MM/YYYY"
                  :disabled="item.sinExistencia"
                ></v-text-field>
              </template>
              <v-date-picker
                @input="(val) => { item.aniosVigencia = formatDate(val); item._menuVig = false }"
              ></v-date-picker>
            </v-menu>
          </template>
          <template v-slot:[`item.sinExistencia`]="{ item }">
            <v-chip v-if="item.sinExistencia" small color="error" text-color="white">Sin existencias</v-chip>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12" class="d-flex justify-center pb-2">
        <v-btn
          color="secondary"
          class="ui-module-btn-solid"
          @click="triggerSaveAsignacion()"
          :loading="loading"
          :disabled="loading || itemsAsignar.filter((i) => !i.sinExistencia).length === 0"
        >
          Registrar asignación de items
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { DEFAULT_EQUIPMENT_DATE, ESTATUS_EQUIPO_ACTIVO } from '@/const'

export default {
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      loadingItems: false,
      menuFechaSolicitud: false,
      menuFechaAsignacion: false,
      selectedItems: [],
      itemsAsignar: [],
      form: {
        fechaSolicitud: '',
        fechaAsignacion: '',
        observaciones: '',
        folioResguardo: '',
        file: null,
      },
      headers: [
        { text: 'Item', value: 'nombre' },
        { text: 'Número / Folio', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Vigencia', value: 'aniosVigencia' },
        { text: '', value: 'sinExistencia', sortable: false },
      ],
    }
  },

  async mounted() {
    await Promise.all([this.fetchTiposItem(), this.fetchEquipo()])
  },

  computed: {
    ...mapGetters('item', { catalogoItems: 'getItems' }),
    ...mapGetters('equipo', { equipos: 'getEquipos' }),

    fechaSolicitud() {
      return this.form.fechaSolicitud
        ? moment(this.form.fechaSolicitud).format(this.API_DATE_FORMAT)
        : DEFAULT_EQUIPMENT_DATE
    },

    fechaAsignacion() {
      return this.form.fechaAsignacion
        ? moment(this.form.fechaAsignacion).format(this.API_DATE_FORMAT)
        : DEFAULT_EQUIPMENT_DATE
    },
  },

  watch: {
    'form.folioResguardo'(val) {
      this.itemsAsignar.forEach((item) => {
        if (!item.sinExistencia && !item.numero) item.numero = val
      })
    },
  },

  methods: {
    ...mapActions('tipoItem', ['fetchTiposItem']),
    ...mapActions('equipo', ['fetchEquipo', 'updateEquipo']),
    ...mapActions('asignacionEquipo', ['saveAsignacionEquipo']),
    ...mapActions('dialog', ['closeDialog']),

    formatDate(val) {
      return val ? moment(val).format(this.API_DATE_FORMAT) : ''
    },

    nombreCompletoItem(catItem) {
      const tipo = catItem.CatTipoItem && catItem.CatTipoItem.title
      return tipo ? `${catItem.item} ${tipo}` : catItem.item
    },

    onItemsChange() {
      this.loadingItems = true

      const tablaAnterior = new Map(this.itemsAsignar.map((i) => [i.fk_idCatItem, i]))

      const nuevaTabla = []
      const itemsSinStock = []
      const idsAEliminar = new Set()

      for (const catItem of this.selectedItems) {
        if (tablaAnterior.has(catItem.id)) {
          nuevaTabla.push(tablaAnterior.get(catItem.id))
          continue
        }
        const equipo = this.obtenerEquipoDisponible(catItem.id)
        if (!equipo) {
          itemsSinStock.push(this.nombreCompletoItem(catItem))
          idsAEliminar.add(catItem.id)
        } else {
          nuevaTabla.push({
            idEquipamiento: equipo.idEquipamiento,
            fk_idCatItem: catItem.id,
            nombre: this.nombreCompletoItem(catItem),
            numero: this.form.folioResguardo || '',
            fechaFabricacion: '',
            aniosVigencia: '',
            _menuFab: false,
            _menuVig: false,
          })
        }
      }

      if (itemsSinStock.length) {
        this.$store.commit(
          'SET_SNACKBAR_MESSAGE',
          `Los siguientes items no cuentan con existencias suficientes: ${itemsSinStock.join(', ')}.`
        )
      }
      if (idsAEliminar.size) {
        this.$nextTick(() => {
          this.selectedItems = this.selectedItems.filter((i) => !idsAEliminar.has(i.id))
        })
      }

      this.itemsAsignar = nuevaTabla
      this.loadingItems = false
    },

    // Devuelve un equipo ACTIVO disponible del inventario para el catItem dado,
    // excluyendo los que ya están en la tabla actual. Null si no hay ninguno.
    obtenerEquipoDisponible(catItemId) {
      const idsEnUso = new Set(this.itemsAsignar.map((i) => i.idEquipamiento))
      return (
        this.equipos.find(
          (e) =>
            e.CatItem &&
            e.CatItem.id === catItemId &&
            e.CatEstatus &&
            e.CatEstatus.id === ESTATUS_EQUIPO_ACTIVO &&
            !idsEnUso.has(e.idEquipamiento)
        ) || null
      )
    },

    async triggerSaveAsignacion() {
      this.loading = true

      try {
        const itemsConExistencia = this.itemsAsignar.filter((i) => !i.sinExistencia)

        for (const item of itemsConExistencia) {
          const equipoInventario = this.equipos.find((e) => e.idEquipamiento === item.idEquipamiento)
          if (equipoInventario) {
            await this.updateEquipo({
              ...equipoInventario,
              idEquipamiento: item.idEquipamiento,
              numero: item.numero || equipoInventario.numero,
              fechaFabricacion: item.fechaFabricacion || equipoInventario.fechaFabricacion,
              aniosVigencia: item.aniosVigencia || equipoInventario.aniosVigencia,
            })
          }
        }

        await this.saveAsignacionEquipo({
          fk_idPersonal: this.idPersonal,
          fechaSolicitud: this.fechaSolicitud,
          fechaAsignacion: this.fechaAsignacion,
          observaciones: this.form.observaciones,
          evidencia: this.form.file ? this.form.file.name : '',
          folioResguardo: this.form.folioResguardo,
          equipoAsignado: itemsConExistencia.map((item) => ({
            fk_idEquipo: item.idEquipamiento,
            nombre: item.nombre,
          })),
          file: this.form.file,
        })

        this.closeDialog()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-file-input__text,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-calendar,
::v-deep .ui-form-field .mdi-paperclip {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #ffbe76 !important;
  font-weight: 600;
}

::v-deep .ui-form-field .v-input__prepend-inner .v-icon,
::v-deep .ui-form-field .v-input__append-inner .v-icon,
::v-deep .ui-form-field .v-input__append-outer .v-icon {
  color: rgba(255, 159, 67, 0.7) !important;
}

::v-deep .ui-form-field.ui-form-textarea .v-input__slot {
  align-items: flex-start !important;
}

.table-cell-text {
  color: #e0e0e0;
  font-size: 0.875rem;
}

.red--text {
  color: #ff5252 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .v-menu__content {
  background: rgba(46, 36, 22, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 159, 67, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
  padding: 8px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  color: #e0e0e0 !important;
  transition: all 0.2s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(255, 159, 67, 0.15) !important;
}

::v-deep .v-list-item--active {
  background: rgba(255, 159, 67, 0.2) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: inherit !important;
}

::v-deep .v-date-picker-table {
  background: rgba(46, 36, 22, 0.6) !important;
}

::v-deep .v-date-picker-header {
  background: rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-date-picker-title {
  color: #e0e0e0 !important;
}

::v-deep .v-btn--active {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
}

::v-deep .v-date-picker-table__current {
  border: 2px solid #ff9f43 !important;
  color: #ffbe76 !important;
}

::v-deep .v-date-picker-header .v-btn,
::v-deep .v-date-picker-table tbody .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-header .v-btn:hover,
::v-deep .v-date-picker-table tbody .v-btn:hover {
  background: rgba(255, 159, 67, 0.2) !important;
}
</style>
